import { render, staticRenderFns } from "./HorizontalScreen.vue?vue&type=template&id=599214b2&scoped=true"
import script from "./HorizontalScreen.vue?vue&type=script&lang=js"
export * from "./HorizontalScreen.vue?vue&type=script&lang=js"
import style0 from "./HorizontalScreen.scss?vue&type=style&index=0&id=599214b2&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "599214b2",
  null
  
)

export default component.exports